<!-- ===== Header ===== -->
<div class="card shadow-sm border-0 mb-3">
  <div class="card-body py-3">
    <h4 class="card-title mb-0 fw-semibold">
      {{ 'MENU.DASHBOARD.religious_inquiries' | translate }}
    </h4>
  </div>

<!-- ===== Form Card ===== -->
<div class="card shadow-sm border-0">
  <div class="card-body">

    <form (ngSubmit)="onSubmit()" enctype="multipart/form-data">

      <div class="row justify-content-center">
        <div class="col-lg-8">

<!-- Question -->
<div class="mb-3">
  <label class="form-label fw-medium">
    {{ lang === 'ar' ? 'السؤال' : 'Question' }}
  </label>

  <textarea
    class="form-control"
    rows="3"
    placeholder="{{ lang === 'ar' ? 'السؤال' : 'Question' }}"
    [(ngModel)]="formData.question"
    name="question"
  ></textarea>

  <small class="text-danger" *ngIf="errors?.question">
    {{ errors.question[0] }}
  </small>
</div>
          <!-- Submit -->
          <div class="d-flex justify-content-end">
            <button type="submit" class="btn btn-primary px-4">
              {{ 'MENU.DASHBOARD.Add' | translate }}
            </button>
          </div>

        </div>
      </div>

    </form>

  </div></div>

</div>
